import { AxiosResponse } from 'axios';

import legacyApiClient from '~/app/shared/util/api/legacyApiClient';
import { ACCEPTED_FILE_TYPES } from './upload';

const getAcceptableFiles = (files?: FileList | File[] | null): File[] => {
    return files ? Array.from<File>(files).filter(file => ACCEPTED_FILE_TYPES.includes(file.type)) : [];
};

export const uploadFiles = async (files?: FileList | File[] | null, voucherNumber?: number, documentNumber?: number) => {
    const acceptableFiles = getAcceptableFiles(files);

    if (acceptableFiles.length) {
        const data = new FormData();
        const params = ['Upload=1'];

        if (voucherNumber) {
            params.push(`journalEntryId=${voucherNumber}`);
        }
        if (documentNumber) {
            params.push(`pictureNumber=${documentNumber}`);
        }

        acceptableFiles.forEach(file => data.append('files[]', file, file.name));

        const response = await legacyApiClient.post(`/Handlers/DayBookAttachment.ashx?${params.join('&')}`, data);

        return response;
    }

    return { data: null };
};

export const deletePage = async (pageNumber: number, documentNumber?: number): Promise<AxiosResponse> => {
    const params = ['Delete=1'];
    params.push(`pictureNumber=${documentNumber}`);
    params.push(`pageNumber=${pageNumber}`);
    const response = await legacyApiClient.post(`/Handlers/DayBookAttachment.ashx?${params.join('&')}`);
    return response;
};
